import styled, { css } from 'styled-components';

import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import InputSimple, { nameDecorator, phoneDecorator } from '@r1-frontend/ui-react/components/inputSimple';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { breakPoints } from '~/src/constants/breakpoints';

import {
    Col as ColCommon,
    Row,
} from '~/src/features/center/common/styled';

const InputNameDecorator = nameDecorator(InputSimple);
const InputPhoneDecorator = phoneDecorator(InputSimple);

const CommonInputCss = css`
    width: 100%;
    margin-bottom: 0;

    @media (max-width: 600px) {
        width: 100%;
        max-width: 100%;
        margin-right: 0;
    }
`;

export const Button = styled(BaseButton)`
    width: 100%;
    min-width: 100%;
    z-index: 8;
    padding: 12px 24px;
    height: 48px;

    @media (max-width: ${breakPoints.mobile}) {
        width: 100%;
        ${FONTS.XS};
    }
`;

export const InputName = styled(InputNameDecorator)`
    ${CommonInputCss}
`;

export const InputPhone = styled(InputPhoneDecorator)`
    ${CommonInputCss}
`;

export const Form = styled.div`
    max-width: 100%;
    width: 100%;
    height: 45px;
    position: relative;
    justify-content: center;

    @media (max-width: ${breakPoints.mobile}) {
        max-width: 100%;
    }
`;

export const ColInput = styled(ColCommon)`
    flex-basis: 30%;
    max-width: 32%;
    margin-bottom: 5px;
    padding-left: 4px;
    padding-right: 4px;

    @media (min-width: ${breakPoints.desktop}) {
        margin-bottom: 0;
    }

    @media (max-width: ${breakPoints.tablet}) {
        max-width: 100%;
        margin-bottom: 0;
    }

    @media (max-width: ${breakPoints.mobile}) {
        margin-bottom: 10px;
        flex-basis: 100%;
        padding-left: 0;
        padding-right: 0;
    }
`;

export const ColButton = styled(ColCommon)`
    flex-basis: 20%;
    padding-left: 4px;
    padding-right: 4px;

    @media (max-width: ${breakPoints.desktop}) {
        flex-basis: 40%;
    }

    @media (max-width: ${breakPoints.tablet}) {
        flex-basis: 60%;
    }

    @media (min-width: 768px) and (max-width: 1278px) {
        max-width: 34%;
    }

    @media (max-width: ${breakPoints.mobile}) {
        flex-basis: 100%;
        padding-left: 0;
        padding-right: 0;
    }
`;

export const RowSlot = styled(Row)`
    padding: 8px 4px;
    border-radius: 4px;

    @media (max-width: ${breakPoints.mobile}) {
        flex-direction: row;
        max-width: 100%;
        padding: 8px 0;
    }

    @media (max-width: ${breakPoints.desktop}) and (min-width: 1278px) {
        flex-direction: column;
        max-width: 100%;
    }

    & ${ColButton} {
        flex-basis: 34%;
        max-width: 34%;
    }

    & ${ColButton} {
        @media (max-width: ${breakPoints.desktop}) {
            max-width: 100%;
        }

        @media (max-width: ${breakPoints.desktop}) and (min-width: 1278px) {
            flex-basis: 30%;
        }

        @media (max-width: ${breakPoints.mobile}) {
            flex-basis: 100%;
        }
    }

    & ${ColInput} {
        @media (max-width: ${breakPoints.desktop}) {
            max-width: 100%;
        }
    }

    @media (min-width: ${breakPoints.mobile}) and (max-width: 1278px) {
        flex-direction: row;
        padding-left: 0;
        padding-right: 0;
    }
`;
